import { Path, Svg } from 'react-native-svg';
import { IconProps } from './types';
import { StyleProp, ViewStyle } from 'react-native';

export const IconMail = ({
  width = 24,
  height = 24,
  color,
  style = {},
}: IconProps & { style: StyleProp<ViewStyle> }) => (
  <Svg width={width} height={height} viewBox="0 -960 960 960" style={style}>
    <Path
      d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm640-480L501-453q-5 3-10.5 4.5T480-447q-5 0-10.5-1.5T459-453L160-640v400h640v-400ZM480-520l320-200H160l320 200ZM160-640v10-59 1-32 32-.5 58.5-10 400-400Z"
      fill={color}
    />
  </Svg>
);
